export default __webpack_public_path__ + "static/media/blog.6c01fc78.svg";